import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { MediaImageModel } from '@modules/media/models/media-image.model';
import { MediaVideoModel } from '@modules/media/models/media-video.model';

import { MediaComponent } from '../../../media/media.component';
import { AnnouncementBannerLayoutType } from '../../models/announcement-banner.model';
import { AnnouncementModel } from '../../models/announcement.model';

import { AnnouncementComponent } from './announcement/announcement.component';

@Component({
  selector: 'mb-announcement-banner-large',
  templateUrl: './announcement-banner-large.component.html',
  styleUrls: ['./announcement-banner-large.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MediaComponent, RouterLink, AnnouncementComponent],
})
export class AnnouncementBannerLargeComponent {
  @Input() titleHash: string = '';
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() fuelLabel: string = '';
  @Input() hideAnnouncements: boolean = false;

  @Input() layout = AnnouncementBannerLayoutType.NORMAL;

  @Input() teasers: AnnouncementModel[] = [];

  @Input() links: { link: string; label: string; queryParams?: { [key: string]: any } }[] = [];
  @Input() media!: MediaImageModel | MediaVideoModel;
  @Input() isBelowCountdown: boolean = false;
}
